import Model from "./base/model";

class Shipper extends Model {
  resourceName() {
    return "shippers";
  }

  fields() {
    return {
      social_reason: "",
      cnpj: "",
      fantasy_name:"",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      is_subsidiary: "",
      transporters: { jsonApi: "hasMany", type: "transporters"},
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "adresses" },
      subsidiaries: { jsonApi: "hasMany", type: "shippers" },
      parent: { jsonApi: "hasOne", type: "shippers" },
      pgr_files: {jsonApi: "hasOne", type: "pgr_files"},
      plans: {jsonApi: "hasOne", type: "plans"},
      two_factor_authentication: "",
      billing_closing_day: "",
      new_billing_closing_day: "",
      is_matriz: "",
      parent_id: "",
      is_annual_plan: true,
      selected_plan: null,
      selected_plan_id: null,
      suppliers: { jsonApi: "hasMany", type: "suppliers"},
      table_model: {jsonApi: "hasOne", type: "shipper_table_model"},
      custom_settings: {jsonApi: "hasOne", type: "company_custom_settings"},
      receive_notification: "",
      configurations_audit: { jsonApi: "hasMany", type: "configurations_audit"},
      correios_modals_transport: { jsonApi: "hasMany", type: "correios_modals_transport"},
      survey_feature_preference: "",
      nfe_email:"",
      quotation_approval_percentage_value: "",
    };
  }

  async setCustomer(id, data) {
    return this.request(
      this.resourceName() + "/customers/set/" + id,
      "POST",
      {},
      data
    );
  }
  async unsetCustomer(id, data) {
    return this.request(
      this.resourceName() + "/customers/unset/" + id,
      "POST",
      {},
      data
      );
    }

  async setTransporter(id, data) {
    return this.request(
      this.resourceName() + "/transporters/set/" + id,
      "POST",
      {},
      data
    );
  }

  async unsetTransporter(id, data) {
    return this.request(
      this.resourceName() + "/transporters/unset/" + id,
      "POST",
      {},
      data
    );
  }

  async setSupplier(id) {
    return this.request(
      this.resourceName() + "/suppliers/set/" + id,
      "POST",
      {},
      {}
    );
  }

  async unsetSupplier(id) {
    return this.request(
      this.resourceName() + "/suppliers/unset/" + id,
      "POST",
      {},
      {}
    );
  }
  async setNFeEmail(id,data){
    return this.request(
      this.resourceName() + "/nfe_email/set/" + id,
      "POST",
      {},
      data
    );
  }

  async getShipperRelatedToTransporter(transporterId) {
    return this.request(
      this.resourceName() + "/onboarding/" + transporterId,
      "GET",
      {},
      {},
    )
  }
}

export default new Shipper();
